export default "__VITE_ASSET__B0$821H2__"